module.exports = __webpack_public_path__ + "off_ramp_left.svg?4c13d5b761feed5a20d87d0cb8f17b59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/off_ramp_left.svg
// module id = 196
// module chunks = 0